import { useMediaQuery } from "@mui/material";

export const useIsDesktopOrTablet = () => useMediaQuery("(min-width: 1024px)");
